export default __webpack_public_path__ + "static/media/Idea.1d801816.svg";